import React, { Component } from 'react'
import './InstantBookingHow.scss'

class InstantBookingHow extends Component {

    constructor(props) {
        super(props)
    }

    static propTypes = {
        containerClassName: React.PropTypes.string,
    }

    render() {
        return (
            <section className={["InstantBookingHow", this.props.containerClassName || "container"].join(' ')}>
                <div className="InstantBookingHow-header">Как происходит перевозка с Везёт Всем</div>
                <ol>
                    <li>Еще до нашего с вами знакомства, мы уже проверили вашего будущего исполнителя.
                        Перевозчик загрузил нам основные документы и верифицировал свой транспорт. Он
                        имеет положительную репутацию и хорошие отзывы от других заказчиков. «Везёт
                        Всем» это источник постоянной работы для водителей и даже один негативный отзыв
                        от нашего клиента может привести к удалению перевозчика из базы сервиса, поэтому
                        исполнители особенно трепетно относятся к заказам от наших пользователей.
                    </li>
                    <li>Вы указываете грузы и маршрут перевозки, а мы рассчитываем цену <strong>именно под вашу
                        перевозку</strong>. В отличие от наших конкурентов, эта цена всегда окончательна. Без
                        ограничений по времени, без переплат за дополнительные часы или услуги.
                    </li>
                    <li>В стоимость, которую вы видите уже включена бесплатная страховка даже Б/У груза
                        с покрытием до 100&nbsp;000&nbsp;₽. Страхование осуществляется компанией САО «ВСК».
                    </li>
                    <li>Сейчас вам необходимо будет перепроверить свой заказ, если необходимо добавить
                        грузы или необходимые услуги. Это важно, ведь все что вы указали в заявке будет
                        добавлено в ваш договор на перевозку, который имеет юридическую силу. Если после
                        бронирования транспорта у вас изменятся условия перевозки, сообщите нам об этом
                        заранее.
                    </li>
                    <li>
                        Если вдруг ваша перевозка отменится не позднее 5 часов до начала погрузки – мы вернем
                        вам деньги.
                    </li>
                    <li>После бронирования транспорта, наш менеджер свяжется с вами, чтобы еще раз
                        утвердить все датели перевозки.
                    </li>
                    <li>Когда все будет согласовано, мы назначим вам исполнителя. Мы автоматически
                        отправим вам его контакты и документы на электронную почту и в СМС. А также все
                        данные будут доступны в личном кабинете.
                    </li>
                    <li>После перевозки, мы будем благодарны, если вы оставите отзыв о перевозчике и о
                        сервисе! Как это сделали <a target="_blank" href="/otzyvy/pereezd/kvartirnyj_pereezd">уже
                            более 42 475 заказчиков</a>.
                    </li>
                </ol>
            </section>
        )
    }
}

export default InstantBookingHow



// WEBPACK FOOTER //
// ./client/components/InstantBookingHow/InstantBookingHow.js